<template>
	<div class="courseCenter bg-[#e8f6ff]">
		<div class="relative">
			<img src="@/assets/app_download.png" class="w-[100%]" alt="" />
			<div class="text-center text-[#333333] my-[8px] text-[20px] font-bold">
				ipad设备设置教程
			</div>
			<img src="@/assets/ios_app_download.png" class="w-[100%]" alt="" />
		</div>
		<img class="fixed w-[360px] h-[60px] bottom-[2%] btn" src="@/assets/btn.png" alt="" @click="downloadClick()" />
		<!-- <button class=" w-[88%] h-[6.4vh] bg-[#1888fb] text-[18px] font-bold text-white  bottom-[2%] left-[6%] ">立即下载APP</button> -->
	</div>

</template>
<script>
	export default {
		data() {
			return {
				system_app: ''
			}
		},
		mounted() {
			this.getconfig()
		},
		methods: {
			getconfig() {
				this.$api.config({}).then((res) => {
					this.system_app = res.data.system_app
				}).catch((error) => {})
			},
			downloadClick() {
				window.location.href = this.system_app
			},
		}
	}
</script>
<style>
	.btn {
		left: 50%;
		transform: translateX(-50%);
	}

	button {
		border: 0;
		border-radius: 10px;
	}
</style>